import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	reduxForm,
	initialize
} from "redux-form";

import {
	ProgressIndicator
} from "rhombus-react";

import { updateVersionVariables } from "reducers/VersionDetails";


import { useTooltipRebuild } from "hooks/useTooltipRebuild";
import { getVariables, flattenMap, flattenMap2 } from "utils/VersionHelpers";

import { EDIT_SOCIAL_VERSION_2 } from "forms/list";

import getSocialFields from "social/formats/VersionMapping";

import VariableRow from "./VariableRow";
import { buildVersionErrors } from "./validators";

import "./EditSocialVersion.css";


export function EditSocialVersion(props){
	let {
			libraryId,
			creativeId,
			versionId,
			variables,
			handleSubmit,
			closeModal,
		} = props
		, dispatch = useDispatch()
		, {
			socialValues,
			adType,
			isLoading,
		} = useSelector((state) => {
			let isLoading = [
				state.versionDetails.isSavingVariables
				, !state.creativeVersions.isLoaded
				, !state.creativeDetails.isLoaded
			].some(v => v);

			return {
				socialValues:state.creativeDetails.socialValues || {},
				adType:state.creativeDetails.adType,
				isLoading,
			};
		})
		;

	let creativeMapping = useMemo(() => {
		return getSocialFields(adType);
	}, [adType]);


	let mappings = useMemo(() => {
		let mm = {};

		variables.forEach(v => mm[v.name] = { ...v });

		return flattenMap(socialValues, mm);
	}, [variables, socialValues]);

	let mapping2 = useMemo(() => {
		let mm = {};

		variables.forEach(v => mm[v.name] = { ...v });
		return flattenMap2(socialValues, mm);
	}, [variables, socialValues]);

	useEffect(() => {
		let initialValues = { adType, ...mapping2 };

		console.group("Map2");
		console.log("mapping2", mapping2);
		console.log("InitialValues2", initialValues);
		console.groupEnd();

		// dispatch(initialize(EDIT_SOCIAL_VERSION_2, initialValues));
	}, [adType, mapping2]);


	useEffect(() => {
		let initialValues = { adType };

		variables.forEach((v) => {
			initialValues[v.name] = {
				...v,
				mapping:mappings?.[v.name]?.mapping, /*
				* We need to add the mapping here for validation
				* The validators go by the `socialValues.fieldName` property
				* But the field.names at the Version level are the variable names
				* flattenMap() above builds that mapping for us
				*
				* TODO: maybe consolidate the loops somehow?
				*/
			};
		});

		console.group("Map1");
		console.log("mapping", mappings);
		console.log("InitialValues", initialValues);
		console.groupEnd();
		dispatch(initialize(EDIT_SOCIAL_VERSION_2, initialValues));
	}, [variables, adType, mappings]);

	useTooltipRebuild(mapping2);

	function onSubmit(values){
		dispatch(updateVersionVariables(libraryId, creativeId, versionId, getVariables(values, libraryId)))
			.then((resp) => {
				if(resp.success){
					closeModal();
				}
			});
	}

	return (
		<form id={EDIT_SOCIAL_VERSION_2} className="social-version-form" onSubmit={handleSubmit(values => onSubmit(values))}>
			<ProgressIndicator isLoading={isLoading} />
			{variables.map((v) => {
				return (
					<VariableRow
						key={v.name}
						{...v}
						adType={adType}
						mapping={mappings?.[v.name]?.mapping}
						creativeFields={creativeMapping}
					/>
				);
			})}
		</form>
	);
}

function handleValidate(values, props){
	let { adType } = props.values || {}
		, currentErrors = buildVersionErrors(values, adType)
		;

	return currentErrors;
}

export default reduxForm({
	form: EDIT_SOCIAL_VERSION_2,
	validate: handleValidate,
	// destroyOnUnmount: false,
})(EditSocialVersion);
